/**
 * @generated SignedSource<<f78abb2e4652a83e8259ae8bd5d4a21c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamPicker_userTeams$data = {
  readonly list: ReadonlyArray<{
    readonly teamId: string;
    readonly teamName: string;
  }>;
  readonly " $fragmentType": "TeamPicker_userTeams";
};
export type TeamPicker_userTeams$key = {
  readonly " $data"?: TeamPicker_userTeams$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamPicker_userTeams">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamPicker_userTeams",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "list",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "teamId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "teamName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamList",
  "abstractKey": null
};

(node as any).hash = "42ab745c497f9d59208a06b59dac0d45";

export default node;
